export const CUSTOMERS_SECTION_ID = 'customers';
